<div class="content-container" *ngIf="!showLoader">
    <div class="popup-header">
        <span class="fw-bold"
            >{{ 'callRecordSms' | translate }} <span class="recipients-count"></span></span
        >
        <button class="close-btn flex-center" mat-dialog-close>
            <span class="material-symbols-outlined close-dialog-btn flex-center">close</span>
        </button>
    </div>
    <div class="delivered-counter-status">
        <div class="w-100 my-4 d-flex gap-3 align-items-center" *ngIf="getDeliveredMessagesCounter()">
            <div class="user-image">
                <img src="assets/images/delivered-icon.svg" />
            </div>
            <div>
                <div class="message-delivered-status">{{ 'messageDelivered' | translate }}</div>
            </div>
        </div>
        <div class="w-100 my-4 d-flex gap-3 align-items-center" *ngIf="!getDeliveredMessagesCounter()">
            <div class="user-image">
                <img src="assets/images/not-delivered-icon.svg" />
            </div>
            <div class="message-delivered-status">{{ 'messageNotDelivered' | translate }}</div>
            <div class="resend-button" (click)="resendSms()" [class.disabled]="isRetrying">
                <div class="resend-content">
                    <img 
                        src="assets/images/rotateSMS.svg" 
                        alt="resend sms icon" 
                        class="resend-icon"
                        [class.rotating]="isRetrying"
                    />
                    <span class="resend-text">{{ 'resend' | translate }}</span>
                </div>
            </div>
        </div>
        
        <!-- Success/Error confirmation messages inside popup -->
        <div class="retry-feedback-container" *ngIf="retrySuccess || retryError">
            <div class="retry-success-message" *ngIf="retrySuccess">
                <div class="d-flex gap-2 align-items-center">
                    <i class="fa fa-check-circle success-icon"></i>
                    <span class="success-text">{{ 'smsResendSuccessPopup' | translate }}</span>
                </div>
            </div>
            <div class="retry-error-message" *ngIf="retryError">
                <div class="d-flex gap-2 align-items-center">
                    <i class="fa fa-exclamation-triangle error-icon"></i>
                    <span class="error-text">{{ 'smsResendErrorPopup' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
    
    <div>
        <div class="d-flex justify-content-between div-body-sms">
            <label class="input-label my-2 fw-bold">{{ 'messageBody' | translate }}</label>
            <div class="d-flex createDate">
                <label class="input-label my-2 fw-bold">{{ 'createDate' | translate }} :</label> 
                <p class="body_Create"> {{ smsCallRecordDetails?.createdAt | dateFormat : 'd MMM YYYY - h:mm ' | async }}</p>
            </div>
        </div>
        <p class="message-body" dir="auto">{{ messageSplit }}</p>
    </div>
 
</div>
<app-loader *ngIf="showLoader"></app-loader>